export default "__VITE_ASSET__DVDo1aAo__"